import { observer } from 'mobx-react-lite';
import React, { Fragment, useEffect } from 'react';
import { isInternal } from '@/infrastructure/auth';
import { Loading } from '@/presentation/components/loading';
import { LiteLayout } from '@/presentation/layouts/lite';
import NoPermission from '@/presentation/pages/exception/nopermission';
import { useStores } from '@/presentation/store';

export const InternalPermissionWrapper: React.FC = observer((props) => {
  const { hasProduct, initForInternal, loaded } = useStores().ProductStore;
  const isInternalApp = isInternal();
  useEffect(() => {
    isInternalApp && initForInternal();
  }, []);

  const loading = <div style={{ flex: '1' }}>
    <Loading/>
  </div>;

  if (isInternalApp) {
    if (!loaded) {
      return loading;
    }

    if (!hasProduct) {
      return <LiteLayout>
        <NoPermission />
      </LiteLayout>;
    };
  }

  return <Fragment>
    {props.children}
  </Fragment>;
});
